import { useQuery } from '@tanstack/react-query';
import { TestService } from '../TestService';

// Test queries
export const useTest = (id) =>
  useQuery({
    queryKey: ['test', id],
    queryFn: () => TestService.getTest(id),
    enabled: !!id,
  });

export const useTests = ({ pageNo, pageSize, search, status }) =>
  useQuery({
    queryKey: ['tests', 'list', pageNo, pageSize, search, status],
    queryFn: () => TestService.listTests(pageNo, pageSize, search, status),
  });

export const useAllTests = ({
  pageNo = 1,
  pageSize = 10,
  search = '',
  status = 'ACTIVE',
  enabled = true,
} = {}) =>
  useQuery({
    queryKey: ['tests', 'all', pageNo, pageSize, search, status],
    queryFn: () => TestService.listAllTests(pageNo, pageSize, search, status),
    enabled,
  });

// TestGroup queries
export const useTestGroup = (id) =>
  useQuery({
    queryKey: ['test-group', id],
    queryFn: () => TestService.getTestGroup(id),
    enabled: !!id,
  });

export const useTestGroups = ({ pageNo, pageSize, search, status }) =>
  useQuery({
    queryKey: ['test-groups', 'list', pageNo, pageSize, search, status],
    queryFn: () => TestService.listTestGroups(pageNo, pageSize, search, status),
  });

export const useAllTestGroups = ({
  pageNo = 1,
  pageSize = 10,
  search = '',
  status = 'ACTIVE',
  enabled = true,
} = {}) =>
  useQuery({
    queryKey: ['test-groups', 'all', pageNo, pageSize, search, status],
    queryFn: () =>
      TestService.listAllTestGroups(pageNo, pageSize, search, status),
    enabled,
  });

// TestCollection queries
export const useTestCollection = (id) =>
  useQuery({
    queryKey: ['test-collection', id],
    queryFn: () => TestService.getTestCollection(id),
    enabled: !!id,
  });

export const useTestCollections = ({
  pageNo,
  pageSize,
  search,
  status,
  enabled = true,
}) =>
  useQuery({
    queryKey: ['test-collections', 'list', pageNo, pageSize, search, status],
    queryFn: () =>
      TestService.listTestCollections(pageNo, pageSize, search, status),
    enabled,
  });
